import { useState, useEffect } from 'react';
import axios from 'axios';

export const useProject = (projectId) => {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  // Load project on mount
  useEffect(() => {
    const fetchProject = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/projects/${projectId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        setProject(response.data.project);
      } catch (error) {
        console.error('Error fetching project:', error);
        setError('Failed to load project');
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [projectId]);

  // Listen for project settings event from Header
  useEffect(() => {
    const handleOpenProjectSettings = () => {
      setShowSettingsModal(true);
    };

    window.addEventListener('openProjectSettings', handleOpenProjectSettings);

    return () => {
      window.removeEventListener('openProjectSettings', handleOpenProjectSettings);
    };
  }, []);

  // Clear header icons when navigating to project dashboard
  useEffect(() => {
    // Dispatch event to clear header icons (search, download, etc.)
    window.dispatchEvent(new CustomEvent('clearHeaderIcons'));
  }, [projectId]); // Trigger when projectId changes (navigation)

  const handleProjectUpdated = (updatedProject) => {
    setProject(updatedProject);
  };

  return {
    project,
    loading,
    error,
    showSettingsModal,
    setShowSettingsModal,
    handleProjectUpdated,
    setError
  };
}; 